import React from 'react';
import { batch, useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { UNANSWERED_URL_SEARCH_PARAM } from 'utils/constants/urlSearchParameters';
import { useTranslation } from 'utils/modifiedTranslation';
import Button from 'new-ui/Components/Button';
import { ROUTE_NAME, ROUTE_PATH } from 'utils/constants/router';
import { closePopups } from 'modules/popup/actions';
import { ReactComponent as CalendarIcon } from './images/calendar.svg';
import contactUsIconSrc from './images/contact-us.svg';
import styles from './intakeOnboarding.module.css';

export const IntakeOnboarding = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const goToIntake = () => {
    batch(() => {
      dispatch(closePopups());
      dispatch(push(`${ROUTE_PATH[ROUTE_NAME.INTAKE]}?${UNANSWERED_URL_SEARCH_PARAM}=1`));
    });
  };

  return (
    <div className={styles.root}>
      <img src={contactUsIconSrc} alt="icon" className={styles.contactIcon} />
      <h2 className={styles.title}>
        {t('intake_onboarding.title')}
      </h2>
      <div className={styles.contentWrapper}>
        <div className={styles.content}>
          <span>
            {t('intake_onboarding.info.results')}
          </span>
          <br />
          <span>
            {t('intake_onboarding.info.mefical_profile')}
          </span>
          <Button
            className={styles.matchesButton}
            action={goToIntake}
            customIcon={<CalendarIcon />}
            title={t('intake_onboarding.button.matches')}
          />
        </div>
        <div className={styles.contactIconWrapper}>
          <img src={contactUsIconSrc} alt="icon" className={styles.contactIcon} />
        </div>
      </div>
    </div>
  );
};
